import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { getFormHasLocationQuestions, getFormIsSubform } from "reduxSlices/formBuilderSlice"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { subtypes as subtypesForType, actionSubtypeLabel, labelForSubtype } from "utils/workflowHelpers"
import { Select } from "shared/selects"

const SelectActionSubtype = ({ changeActionSubtype, type = undefined, value = null }) => {
  const formIsSubform = useSelector(getFormIsSubform)
  const formHasLocationQuestions = useSelector(getFormHasLocationQuestions)

  const facility = useCustomName(FACILITY_KEY)
  const department = useCustomName(DEPARTMENT_KEY)

  const subtypes = subtypesForType(type, { formHasLocationQuestions, formIsSubform })

  if (!subtypes || subtypes.length < 2) return null

  const options = subtypes.map((subtype) => ({
    value: subtype,
    label: actionSubtypeLabel(subtype, { facility, department }),
  }))
  const selectLabel = labelForSubtype(type)

  return (
    <Select
      backspaceDelete={false}
      onChange={changeActionSubtype}
      options={options}
      required
      value={value}
      style={{ height: "32px" }}
      label={selectLabel}
    />
  )
}

SelectActionSubtype.propTypes = {
  changeActionSubtype: types.func.isRequired,
  type: types.string,
  value: types.string,
}

export default SelectActionSubtype
